import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { header } from 'app/_misc/headers';

@Injectable({ providedIn: 'root' })
export class LicensingService {
  constructor(private httpClient: HttpClient) { }

  createSession(formData: FormData) {
    return this.httpClient.post('/licensing/createsession', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => {       
      return response.body; 
    }), catchError(this.handleError));
  }

  validateSession(formData: FormData) {
    return this.httpClient.post('/licensing/validatesession', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  terminateSession(formData: FormData) {
    return this.httpClient.post('/licensing/terminatesession', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }
}